import React from "react";
import Fields from "./fields";
import FormPages from "./form-pages";

function LightboxBuilderFields() {
  return (
    <>
      <FormPages />
      <Fields />
    </>
  );
}

export default React.memo(LightboxBuilderFields);
